import { baseItemBoxProgressStyles } from '@bingads-webui-campaign-react/upload-file-picker';
import { shorthands } from '@fluentui/react-components';

export const getFolderProgressPreviewStyles = {
  imageContent: {
    ...baseItemBoxProgressStyles.imageContent,
    height: '50px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  imageName: {
    display: 'none',
  },
  imageContentText: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: '1',
    flexShrink: '1',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: '9px',
    marginRight: '22px',
    fontSize: '12px',
    ...shorthands.overflow('hidden'),
  },
  folderName: {
    fontWeight: '600',
    flexGrow: '1',
    flexShrink: '1',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
  },
  folderSize: {
    flexGrow: '0',
    flexShrink: '0',
    fontWeight: '400',
  },
  folderIconRoot: {
    display: 'inline-block',
    height: '25.78px',
    width: '34px',
    marginLeft: '13px',
    flexGrow: '0',
    flexShrink: '0',
  },
};
